import {ResponseHomeNewsDetail} from 'common-modules/general/API/news/types';

export interface TopBannerModel {
  typeOpn: string; // 노출유형 (0 : 텍스트형, 1 : 이미지형)
  typeGide: string; // 배너 안내 유형(0 : 일반 안내 / 1 : 주의성 안내 / 2 : 경고성 안내)
  sralAtchPcFile: string; // PC 첨부 파일에 대한 파일 참조 경로 (없으면 빈 스트링 값)
  sralAtchMoFile: string; // Mobile 첨부 파일에 대한 파일 참조 경로 (없으면 빈 스트링 값)
  cntsBanr: string; // 배너 유형이 텍스트형인 경우 텍스트 내용 (없으면 빈 스트링 값)
  urlMvmt: string; // 배너 클릭시 이동되는 URL (없으면 빈 스트링 값)
  ynNewwdw: string; // 배너클릭시 새창 열림 여부 (Y, N)
}

export interface SideBannerModel {
  nmBanr: string; // 사이드 배너명
  typeOpn: string; // 타입 (0: 텍스트형, 1: 이미지형)
  cntsBanr: string; // 텍스트 내용 (없으면 빈 스트링 값)
  urlMvmt: string; // 클릭 시 이동할 URL 주소. 빈 스트링이면 웹에서 무시.
  ynNewwdw: string; // 배너클릭시 새창 열림 여부 (Y, N)
  sralAtchPcFile: string; // 첨부 파일에 대한 파일 참조 경로
  dntRgst: string; // 등록날짜(YYYY-MM-DDTHH:mm:ss)
}

export interface ResponseMainContents {
  contentsOrder: ResponseContentsOrder[]; // 콘텐츠의 표출 순서.
  salesList: ResponseSaleList[]; // GNB 분양 메뉴에 표기될 분양지 리스트.
  mainVisual: ResponseMainVisual; // 메인 비주얼 콘텐츠 정보.
  sales: ResponseSaleContents[]; // 메인 비주얼 분양지 카드 리스트 정보.
  shortcuts: ResponseShortCutList[]; // 메인 비주얼 바로가기 리스트 정보.
  popup: MainContentsPopup | null; // 팝업 여부. 존재하면 null이 아님
  banner: TopBannerModel | null; // 배너 여부. 존재하면 null이 아님
  sideBanner: SideBannerModel[];  // 사이드 배너 (분양페이지 용으로 사이드 배너에 대한 내용)
}

export interface MainContentsPopup {
  sizeWdth: string; // 팝업 사이즈(가로)
  sizehght: string; // 팝업 사이즈(세로)
  codtX: string; // 팝업이 표출 될 X축 시작
  codtY: string; // 팝업이 표출 될 Y축 시작
  ynScrlAble: string; // 팝업의 스크롤 사용 여부 (Y, N)
  urlPpup: string; // 팝업 html로 dangerouslySetInnerHTML을 사용하지 말고
}

export interface ResponseContentsOrder {
  // contents: "mainVisual" | "salesContents" | "shortcut" | "es";
  contents: '02' | '03' | '04' | '05';
  order: number;
}
export interface ResponseSaleList {
  cdBizLnd: string; // 분양지(단지) 코드
  nmBizLnd: string; // 분양지 명
  urlBizLndLnk: string; // 클릭 시 이동할 페이지 주소
}

/**
 * 메인 비주얼 정보
 * 데스크탑과 모바일에 대한 메인 콘텐츠 영상 혹은 이미지의 정보를 넘긴다.
 */
export interface ResponseMainVisual {
  desktop: MainVisual;
  mobile: MainVisual[];
}

export interface MainVisual {
  fullPath: string; // 콘텐츠 파일 위치
  link: string; // 클릭 시 이동할 페이지 주소 (빈 값이면 무시 - 페이지 열기 작동 안 함)
  linkOption: 'Y' | 'N'; // 새 탭으로 열지 여부
}
export interface ResponseSaleContents {
  fullPath: string; // 썸네일 이미지 경로
  state: string[]; // 분양중이라는 state는 주황색 표기
  nmBizLnd: string; // 분양지 명
  urlBizLndLnk: string; // 클릭 시 이동할 페이지 주소
}

/**
 * 바로가기 아이콘 표출 정보
 */
export interface ResponseShortCutList {
  normal_fullPath: string; // 기본 아이콘 이미지 경로
  hover_fullPath: string; // 호버 아이콘 이미지 경로
  title: string; // 타이틀(이름)
  link: string; // 클릭 시 이동할 페이지 주소
}

export interface ResponseFindBizList {
  cdBizLnd: string; // 단지 코드
  cdArea: string; // 지역 코드
  nmBizLnd: string; // 사업지 명
  yRmtSilPln: string; // 분양 계획 년 (ex. 2022, 2021)
  mRmtSilPln: string; // 분양 계획 월 (ex. 1, 2, 3, 4...)
  cdPrgsStat: string[]; // 분양 진행상태 ([ "001", "003"])
  addrBizLnd: string; // 위치
  infoPklt: string; // 세대
  dntCstEnd: string; // 준공 일자 (YYYYMM) - 웹에서 YYYY.MM 형식으로 포맷터를 적용해 주세요.
  urlBizLndLnk: string; // 분양사이트 메인주소
}

export interface ResponseFindBiz {
  summary: {
    [cdArea: string]: number;
  }; // 전국의 데이터 요약

  bizs: ResponseFindBizList[];
}

// // 지역코드 (cdArea)
// 123 수도 4567 충청 5 강원 89 10 11 경상 13 14 15 전라 16 제주 17 기타
export const cdAreaListDetail = {
  '001': '서울',
  '002': '인천',
  '003': '경기',
  '004': '충남',
  '005': '강원',
  '006': '충북',
  '007': '대전',
  '008': '경북',
  '009': '대구',
  '010': '경남',
  '011': '부산',
  '012': '울산',
  '013': '전북',
  '014': '전남',
  '015': '광주',
  '016': '제주',
  '017': '기타'
};

export const cdAreaList = [
  { name: '전국', code: '전국' },
  { name: '수도권', code: '수도권' },
  { name: '충청권', code: '충청권' },
  { name: '강원권', code: '강원권' },
  { name: '경상권', code: '경상권' },
  { name: '전라권', code: '전라권' },
  { name: '제주권', code: '제주권' }
];

// // 분양 진행상태 (cdPrgsStat)
export const cdPrgsStatList = {
  '': '전체',
  '007': '분양완료',
  '006': '입주중',
  '005': '공사완료',
  '004': '공사중',
  '003': '분양중',
  '002': '분양예정',
  '001': '미정'
  // '008': '분양중/공사완료',
  // '009': '분양중/입주중/공사완료',
  // '010': '분양예정/공사중'
};

export const cdPrgsStatOptionsList = [
  { value: '전체', id: '' },
  { value: '분양완료', id: '007' },
  { value: '입주중', id: '006' },
  { value: '공사완료', id: '005' },
  { value: '공사중', id: '004' },
  { value: '분양중', id: '003' },
  { value: '분양예정', id: '002' },
  { value: '미정', id: '001' }
];

export interface ResponseSaleAllList {
  cdBizLnd: string; // 분양지(단지) 코드
  nmBizLnd: string; // 분양지 명
  urlBizLndLnk: string;
}

export interface RequestFindConstructionAPI {
  cdBizLnd: string;
}

export interface ConstructionDayInfo {
  cstDt: string; // 일정(YYYYMMDD)
  imgFileLog: string; // 공사현장 이미지 파일 경로
  imgFileNm: string; // 공사현장 이미지 파일명
}

export interface Construction {
  addrBizLnd: string; // 공사 주소지(사업지 주소)
  nmBiz: string; // 현장명 (단지명)
  noTel: string; // 현장 전화번호 (대표전화)
  cntsNwbdHoshNo: string; // 세대 수 (모든 세대)
  noHoshSum1: string; // 세대 수 (일반 세대)
  sizeInfos: string[]; // 평형 정보 (전용면적, 평면타입, 면적단위를 합친 string을 배열로 ex: 59A㎡ ...)
  prgsRate: string; // 공정률
  curDt: string; // 해당날짜(YYYYMMDD)
  crtPrgsCrst: string; // 공사 개요(SAMHO_SITE_INFO_PMIS에서 CST_PRGS_CRST 참조함)
  imgFileLog: string; // 공사현장 이미지 파일 경로
  imgFileNm: string; // 공사현장 이미지 파일명
  siteDayInfo: Array<ConstructionDayInfo>; // 그 외 공사정보
}

export type ResponseFindConstructionAPI = Construction;
/**
 * @deprecated
 * @현재_사용_안함
 * 메뉴 리스트 DTO
 * 메뉴 코드는 다음과 같습니다.(괄호 안 알파벳)
	- 개요 (A)
	- 분양 (B)
	- 사이버 주택전시관 (C)
	- 입지 (D)
	- 단지 (E)
	- 세대 (F)
	- 이벤트 (G)
	- 소식 (H)
 */
export interface MenuModel {
  mnCode: string; // 메뉴 코드
  mnName: string; // 메뉴 이름
}

/**
 * 분양페이지 기본 정보 DTO
 */
export interface ResponseSalesInfo {
  cdBizLnd: string; // 단지 코드
  nmBizLnd: string; // 단지명
  imgMainLnkPc: string; // 메인 이미지 링크 (PC)
  imgMainLnkMo: string; // 메인 이미지 링크 (Mobile)
  cntsBiz: string; // 분양 상담 전화번호
  cdPrgsStat: string[]; // 분양 진행상태 (001)
  addrBizLnd: string; // 단지 주소
  addrBizExhibLnd: string; // 주택전시관 주소
  cntsNwbdHosh: string; // 총 세대 수
  infoGrndArea: string; // 대지 면적
  infoCstScl: string; // 건축 규모
  infoPklt: string; // 주차장 정보
  ipjuDate: string; // 입주 예정 시기
  ipjuDateText: string; // 입주 예정 시기
  ipjuExhibDate: string; // 주택전시관 예정 시기
  ipjuExhibDateText: string; // 주택전시관 예정 시기
  menuList: MenuModel[]; // 메뉴 리스트
  banner: TopBannerModel | null; // 탑 배너, 만약 이 API 호출 시점에서 시간이 안 맞아 정보가 없을 경우 null 처리.
  sideBanner: SideBannerModel[];
  // 2023-03-02 chaikm
  // ResponseHomeNewsDetail[] -> ResponseHomeNewsDetail로 변경
  news: ResponseHomeNewsDetail; // 개요 > 새소식
  ynTrustcom: string; // 신탁사업지 여부
  nmTrustcom: string;
  drPssText: string;
}

// 분양 진행상태 (cdPrgsStat)
export const cdPrgsStat = {
  '001': '미정',
  '002': '분양예정',
  '003': '분양중',
  '004': '공사중',
  '005': '공사완료',
  '006': '입주중',
  '007': '분양완료'
};
